import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../variables';
import { MetricsRowProps } from './key-metrics-framework.types';
import { PAtom, H4Atom } from '../../atoms/text-atoms/text-atoms';

const MetricsRow: React.FC<MetricsRowProps> = ({
  label,
  children,
  className,
}) => {
  if (label && children) {
    return (
      <div className={className} data-testid="metrics-row">
        <H4Atom className="label">{label}</H4Atom>
        <div className="value">
          <PAtom>{children}</PAtom>
        </div>
      </div>
    );
  } else {
    console.warn(
      `MetricsRow received invalid arguments - label: ${label}, children: ${children}`
    );
    return null;
  }
};

const StyledMetricsRow = styled(MetricsRow)`
  width: 100%;
  padding: 0 0.5rem 2.6rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .label,
  .value {
    ${vars.fontSize4}
    text-align: left;
    vertical-align: top;
  }
  .value {
    ${PAtom} {
      font-weight: ${vars.fontWeightRegular};
      line-height: 110%;
      letter-spacing: 0.0015em;
      margin: 0;
    }
  }

  .label {
    font-weight: ${vars.fontWeightMedium};
    margin-top: ${vars.spacingS};
    padding-right: ${vars.spacingM};
    color: ${vars.plasticsBlue};
  }

  ${H4Atom} {
    padding: 0 0 0.5rem 0;
    margin: 0.5rem 0 0 0;
    margin: 0;
  }
`;

export default StyledMetricsRow;
